import { render } from "./CloseButton.vue?vue&type=template&id=81791414&scoped=true"
const script = {}

import "./CloseButton.vue?vue&type=style&index=0&id=81791414&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81791414"]])

export default __exports__